import { graphql } from '@client/graphql/types';
import { useQuery } from '@apollo/client';

export const QUERY = graphql(`
  query Table($id: ID!) {
    table(id: $id) {
      id
      name
      seats
    }
  }
`);

export function useGetTable(id: string) {
  return useQuery(QUERY, { variables: { id } });
}
